import {v4} from 'uuid';
import projectUtils from "../../../../../../utils/project-utils.js";

const MAX_FILE_SIZE = 2_000_000;

const readImageFile = (files, onLoad) => {
    const file = files[0];

    if (file.size >= MAX_FILE_SIZE) {
        projectUtils.swalErrorMessage('', 'Tamanho máximo de arquivo excedido. Limite: 2MB.', 'Ok');
        return;
    }

    file.url = URL.createObjectURL(file);
    file.attachId = v4();
    file.new = true;

    const reader = new FileReader();
    reader.onload = (e) => onLoad(file, e.target.result);
    reader.readAsDataURL(file);
};

export default readImageFile;